import { Toast } from "vant";

// 判断是ios
if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    var ADDRESS = 'com.sjbox.ios://communityData='
} else {
    var ADDRESS = 'com.sjbox.az://communityData='
}

export function callApp(url) {
    Toast('即将为您下载app...')
    const schema = toboxWebviewUrl(url) || location.pathname + location.search
    console.log(schema);
    const timeOut = 2000
    let timer = null
    let myPromise = new Promise((resolve, reject) => {
        window.location.href = `${ADDRESS}${schema}`;
        window.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "hidden") {
                clearTimeout(timer);
                resolve();
            }
        });
        timer = setTimeout(() => {
            location.href = downLoadUrl()
        }, timeOut);
    });
    return myPromise;
}
export function callAppUrl(url) {
    const schema = toboxWebviewUrl(url) || location.pathname + location.search
    window.location.href = `${ADDRESS}${schema}`;
}

export function downLoadUrl() {
    const advertisingId = localStorage.getItem('advertisingId')
    if (!advertisingId) {
        return `https://bbsnewapi.3975bbs.com/common/packageAppLink`
    }
    return `https://bbsnewapi.3975bbs.com/common/packageAppLink?advertisingId=${advertisingId}`
}

export function toboxWebviewUrl(url) {
    if(!url) return ''
    if(url.includes('http')){
        return encodeURIComponent(appendUrlParams(url, { toboxWebview: 1 }))
    } else {
        return url
    }
    
}

export function appendUrlParams(url, params) {
    if (!url) return url
    if (!params) return url

    const queryParts = []
    if (typeof params === 'string') {
        const trimmed = params.replace(/^[?&]+/, '').trim()
        if (trimmed) queryParts.push(trimmed)
    } else if (typeof params === 'object') {
        Object.keys(params).forEach(key => {
            const value = params[key]
            if (value === undefined || value === null) return
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v === undefined || v === null) return
                    queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(v))}`)
                })
            } else {
                queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
            }
        })
    }

    if (!queryParts.length) return url

    const hashIndex = url.indexOf('#')
    const hasHash = hashIndex >= 0
    const beforeHash = hasHash ? url.slice(0, hashIndex) : url
    const hash = hasHash ? url.slice(hashIndex) : ''

    if (beforeHash.includes('?')) {
        if (beforeHash.endsWith('?') || beforeHash.endsWith('&')) {
            return `${beforeHash}${queryParts.join('&')}${hash}`
        }
        return `${beforeHash}&${queryParts.join('&')}${hash}`
    }
    return `${beforeHash}?${queryParts.join('&')}${hash}`
}
